<div [formGroup]="formValidationGroup">
  <app-password-field [id]="validationIdentifier" [formValidationGroup]="formValidationGroup" [validationIdentifier]="validationIdentifier" [disabled]="isAlwaysEditable ? false : !isEditable"
    [value]="datafield.Value" [secretId]="datafield.SecretId" (valueChange)="onValueChange($event)" (cleared)="onCleared();">
  </app-password-field>
  @if (!isValid) {
    <div class="error">{{ errorText }}</div>
  }
</div>
